<template>
  <div class="admin-page__detail admin-customTablesWrapper">
    <div class="bv-example-row">
      <div class="row">
        <div class="d-none d-md-block d-lg-flex col-md-4 col-lg-3 col-12">
          <div class="layout__box admin-page__box admin-page__box--detail">
            <AppBack :black="true" :route="'/admin/menu/' + customerId + '/' + projectId" :text="'zpet'" />
            <ResellerMenu />
          </div>
        </div>
        <div class="col-md-8 col-lg-9 col-12">
          <AppBack
            :black="true"
            :route="'/admin/menu/' + customerId + '/' + projectId"
            :text="'zpet'"
            class="d-md-none mb-0"
          />
          <div class="layout__content__content layout__content__content--white border-radius pt-5">
            <RouterView :key="$route.fullPath" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Back from "@/components/back.vue" //import Select from "@/components/inputs/select.vue";
import Menu from "@/components/admin/admin/menu.vue"
import { useProjectStore } from "@/store/modules/project"
import { useCustomerStore } from "@/store/modules/customer"
import { useAdminStore } from "@/store/modules/admin"

export default {
  components: {
    AppBack: Back,
    ResellerMenu: Menu
  },
  props: {
    item: Object,
    selectedSubmenu: Number
  },
  setup() {
    const projectStore = useProjectStore()
    const customerStore = useCustomerStore()
    const adminStore = useAdminStore()

    return { projectStore, customerStore, adminStore }
  },
  data() {
    return {
      projectId: this.$router.currentRoute.value.params.projectId,
      customerId: this.$router.currentRoute.value.params.customerId,
      selectedCustomer: {},
      submenu: 1
    }
  },
  computed: {
    customers() {
      return this.customerStore.customerList
    },
    projects() {
      return this.projectStore.projectList
    },
    storedCustomer() {
      return this.customerStore.selectedCustomer
    }
  },
  watch: {
    customers() {
      this.item ? (this.selectedCustomer = this.item) : (this.selectedCustomer = this.customers[0])
    },
    selectedCustomer() {
      this.adminStore.setCustomer(this.selectedCustomer)
    }
  },
  mounted() {
    if (this.customers) {
      this.storedCustomer ? (this.selectedCustomer = this.storedCustomer) : (this.selectedCustomer = this.customers[0])
    }
  },
  methods: {
    selectCustomer(customer) {
      this.selectedCustomer = customer
    },
    selectSubmenu(submenu) {
      this.$emit("changeSubmenu", submenu)
      this.submenu = submenu
    }
  }
}
</script>

<style lang="scss" scoped></style>
